// extracted by mini-css-extract-plugin
module.exports = {"droppable":"Layout-module--droppable--2TEro","draggable":"Layout-module--draggable--3CeWX"};